/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InvoiceSubType = 'Undefined' | 'Invoice' | 'CorrectedInvoice' | 'GeneralInvoice' | 'CorrectedGeneralInvoice' | 'ProformaInvoice' | 'PaymentTaxDocument' | 'CorrectedPaymentTaxDocument' | 'PaymentDocument' | 'ProductionInvoice' | 'CorrectedProductionInvoice';

export const InvoiceSubType = {
    Undefined: 'Undefined' as InvoiceSubType,
    Invoice: 'Invoice' as InvoiceSubType,
    CorrectedInvoice: 'CorrectedInvoice' as InvoiceSubType,
    GeneralInvoice: 'GeneralInvoice' as InvoiceSubType,
    CorrectedGeneralInvoice: 'CorrectedGeneralInvoice' as InvoiceSubType,
    ProformaInvoice: 'ProformaInvoice' as InvoiceSubType,
    PaymentTaxDocument: 'PaymentTaxDocument' as InvoiceSubType,
    CorrectedPaymentTaxDocument: 'CorrectedPaymentTaxDocument' as InvoiceSubType,
    PaymentDocument: 'PaymentDocument' as InvoiceSubType,
    ProductionInvoice: 'ProductionInvoice' as InvoiceSubType,
    CorrectedProductionInvoice: 'CorrectedProductionInvoice' as InvoiceSubType
};